import React from 'react';
import './../SignIn/SignIn.css';

import { withFirebase } from '../Firebase';

const SignOutButton = ({ firebase }) => (
  <button className="signout_button" type="button" onClick={firebase.doSignOut}>
    Sign Out
  </button>
);

export default withFirebase(SignOutButton);
